import ModalAccessibility from "../../../../../ModalAccessibility";
import ExternalLogger from "../../../../logger/ExternalLogger";

/**
 *  Deprecated Feb. 17, 2021 - Please make updates in react version
 *
 */

var SaveChangesController = function (
    $scope,
    $injector,
    $modalInstance,
    $window,
    $rootScope,
    $translate
) {
    var vm = this;
    var $state = $injector.get("$state");
    var logger = ExternalLogger.getInstance("SaveChangesController");
    var enrollTitle = $translate.instant("header.saveChanges.headline");
    var enrollMessage = $translate.instant("header.saveChanges.description");
    var genericTitle = $translate.instant("header.genericModal.headline");
    var genericMessage = $translate.instant("header.genericModal.description");
    ModalAccessibility.onOpenModal(".modal-content");

    vm.getTitle = function () {
        return $scope.isEnroll ? enrollTitle : genericTitle;
    };

    vm.getMessage = function () {
        return $scope.isEnroll ? enrollMessage : genericMessage;
    };

    vm.onCancelClick = function () {
        $modalInstance.close();
    };

    vm.onContinueClick = function (e) {
        if ($scope.nextVal === "LOGOUT") {
            $rootScope.isIncompleteModalExist = true;
            $scope.logout(e);
        } else if ($scope.nextVal === "SWITCH_PLAN") {
            $rootScope.isIncompleteModalExist = true;
            $scope.switchPlan($scope.newAccount);
        } else if ($scope.nextVal === "ACCOUNT") {
            $rootScope.isIncompleteModalExist = true;
            $scope.activate($scope.funParam, $scope.funParam2, e);
        } else if ($scope.nextVal === "CHANGEACCOUNT") {
            $rootScope.isIncompleteModalExist = true;
            $scope.changeAccount($scope.currentAccount);
        } else if ($scope.nextVal === "NOTIFICATION") {
            $rootScope.isIncompleteModalExist = true;
            $scope.notificationContinue();
        } else if ($scope.nextVal != "" && $scope.nextVal != undefined) {
            $window.location.href = $scope.nextVal;
        }
        $modalInstance.close();
    };
};

SaveChangesController.$inject = [
    "$scope",
    "$injector",
    "$modalInstance",
    "$window",
    "$rootScope",
    "$translate"
];

export default SaveChangesController;
